.jo{gap:0.125rem;}